// Print fallback placeholder. Full @media print collapsing the rail into a
// margin glossary is deferred to v1.5 polish per 01_renderer.md. The markup
// already supports it; this component is the seam.

export function PrintFallback() {
  return null;
}
